import React from 'react';
import { StyleSheet, View } from 'react-native';
import { LocationModal } from '../locationModal/LocationModal';
import theme from '../../constants/theme.style.js';
import CustomText from '../customText/CustomText';
import ProfileAvatarBackground from '../profileAvatar/ProfileAvatarBackground';

const styles = StyleSheet.create({
  headerContainer: {
    marginTop: theme.CONTAINER_MARGIN,
    display: 'flex',
    flexDirection: 'row',
    marginLeft: theme.CONTAINER_MARGIN,
    marginRight: theme.CONTAINER_MARGIN,
    paddingBottom: theme.CONTAINER_MARGIN,
    borderBottomWidth: 1,
    borderBottomColor: theme.GREY_MEDIUM_LIGHT_COLOR,
  },
  messageImageContainer: {
    width: 65,
    height: 65,
    borderRadius: 15,
    marginRight: 10,
    backgroundColor: '#d6e8d2',
    justifyContent: 'center',
    alignItems: 'center',
  },
  messageImage: {
    height: 65,
    width: 65,
    borderRadius: 15,
    overflow: 'hidden',
  },
  messageInformation: {
    display: 'flex',
    justifyContent: 'center',
  },
  messageLocation: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 3,
  },
  messageLocationImage: {
    height: 20,
    width: 20,
  },
  messageLocationText: {
    color: theme.GREEN_DARKER_COLOR,
  },
  messageSender: {
    fontSize: theme.FONT_SIZE_HEADLINE,
    color: theme.GREY_DARKER_COLOR,
  },
  messageDate: {
    alignSelf: 'flex-start',
    marginLeft: 'auto',
    color: theme.GREEN_DARKER_COLOR,
  },
});

const daysBetweenToday = (someDate) => {
  const today = new Date();
  const diffTime = today - someDate;
  const diffDays = diffTime / (1000 * 60 * 60 * 24);
  return diffDays;
};

export const MessageDetailHeader = ({ deliverAt, sender, location, recipient, isInbox }) => {
  const date = new Date(deliverAt);
  let dateFromated = '';
  if (daysBetweenToday(date) < 0) {
    dateFromated = `${`0${date.getDate()}`.slice(-2)}/${`0${date.getMonth() + 1}`.slice(
      -2,
    )}/${date.getFullYear()}`;
  } else if (daysBetweenToday(date) < 1) {
    dateFromated = 'Today';
  } else if (daysBetweenToday(date) < 2) {
    dateFromated = 'Yesterday';
  } else if (daysBetweenToday(date) < 7) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    dateFromated = days[date.getDay()];
  } else {
    dateFromated = `${`0${date.getDate()}`.slice(-2)}/${`0${date.getMonth() + 1}`.slice(
      -2,
    )}/${date.getFullYear()}`;
  }
  dateFromated += ` ${`0${date.getHours()}`.slice(-2)}:${`0${date.getMinutes()}`.slice(-2)}`;

  const text = isInbox
    ? `${sender.firstname} @ ${sender.nickname}`
    : `${recipient.firstname} @ ${recipient.nickname}`;
  const avatar = isInbox ? sender.avatar : recipient.avatar;

  return (
    <View style={styles.headerContainer}>
      <View style={styles.messageImageContainer}>
        <ProfileAvatarBackground
          style={styles.messageImage}
          avatar={avatar}
          testID="avatar-image"
        />
      </View>
      <View style={styles.messageInformation}>
        <CustomText style={styles.messageSender}>{text}</CustomText>
        {location !== 'undefined' && <LocationModal location={location} />}
      </View>
      <CustomText testID="date" style={styles.messageDate}>
        {dateFromated}
      </CustomText>
    </View>
  );
};

export default MessageDetailHeader;
